export default {
  disclaimer: {
    summary:
      'Bemærk venligst, at det er dit ansvar at bekræfte, at alle valutaer og skatter er korrekte for den gældende jurisdiktion.',
    extra:
      'Vi angiver disse oplysninger udelukkende af hensyn til din bekvemmelighed og påtager os intet ansvar for rigtigheden af valuta og/eller skatter eller for betalingen af sådanne skatter som en del af vores produkter. Oplysningerne om valuta og skatter heri er udelukkende til informationsformål.',
    show_more: 'Vis mere',
    show_less: 'Vis mindre',
  },
  partner_note:
    'Dette er dine standardindstillinger på partnerniveau. Restauranter under din konto arver automatisk disse værdier, medmindre de tilsidesætter en kategori individuelt.',
  section_title: 'Skattesatser for menupunkter',
  new_category_placeholder: 'Ny kategori',
  form: {
    name: {
      label: 'Skattekategori',
    },
    default_tax_rate: {
      label: 'Standardsats',
      tooltip: 'Bruges som reserve, når en specifik sats for bestillingsmetoden nedenfor er tom.',
    },
    pickup_tax_rate: {
      label: 'Afhentning',
    },
    delivery_tax_rate: {
      label: 'Levering',
    },
    dine_in_tax_rate: {
      label: 'I restauranten',
    },
    room_service_tax_rate: {
      label: 'Roomservice',
    },
    show_zero_tax_in_summary: {
      label: 'Vis 0 % moms i ordreoversigten',
    },
  },
  buttons: {
    add_category: 'Tilføj ny skattekategori',
    cancel: 'Annuller',
    save: 'Gem',
    confirm: 'Slet',
    delete: 'Slet kategori',
    reset: 'Nulstil til arvet',
  },
  delete_confirm: {
    title: 'Slet denne skattekategori?',
    description: 'Dette kan ikke fortrydes.',
  },
  scope_labels: {
    region: 'Hele regionen',
    partner: 'Hele partneren',
    restaurant: 'Hele restauranten',
  },
  confirm_modal: {
    title: {
      fork: 'Gøre den til denne restaurants egen kategori?',
      owned: 'Anvende de nye satser?',
      reset: 'Gå tilbage til den arvede kategori?',
    },
    affected_one: '{{count}} produkt eller kategori er i øjeblikket knyttet og vil blive opkrævet med de nye satser.',
    affected_other:
      '{{count}} produkter og kategorier er i øjeblikket knyttet og vil blive opkrævet med de nye satser.',
    affected_settings_one:
      '{{count}} produkt eller kategori er i øjeblikket knyttet og vil bruge de opdaterede indstillinger.',
    affected_settings_other:
      '{{count}} produkter og kategorier er i øjeblikket knyttet og vil bruge de opdaterede indstillinger.',
    restaurants_one: 'Det er {{count}} restaurant.',
    restaurants_other: 'Det er {{count}} restauranter.',
    acknowledge:
      'Jeg forstår, at en bekræftelse ændrer skattekategorien for alle produkter, der i øjeblikket er knyttet til denne kategori',
    impact_error: 'Det kunne ikke kontrolleres, hvilke produkter dette ville ændre',
    cancel: 'Annuller',
    confirm: 'Bekræft',
  },
  toasts: {
    load_error: 'Skattekategorierne kunne ikke indlæses.',
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
    delete_error: 'Denne skattekategori kunne ikke slettes.',
    category_deleted: 'Skattekategori slettet',
    category_reset: 'Skattekategorien er nulstillet til den arvede',
    reset_error: 'Denne skattekategori kunne ikke nulstilles.',
    impact_error: 'Det kunne ikke kontrolleres, hvilke produkter dette ville ændre',
    impact_changed_one: 'Antallet af berørte produkter er ændret til {{count}}. Gennemgå og bekræft igen.',
    impact_changed_other: 'Antallet af berørte produkter er ændret til {{count}}. Gennemgå og bekræft igen.',
  },
};
